// extracted by mini-css-extract-plugin
export default {"toggle_bg":"ToggleStory_toggle_bg__r5lg-","toggle":"ToggleStory_toggle__LIGzp","night":"ToggleStory_night__TfepK"};